// source: msg_entity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.himpb.EMsg', null, global);
goog.exportSymbol('proto.himpb.EMsg.EncodeType', null, global);
goog.exportSymbol('proto.himpb.EMsg.MsgMode', null, global);
goog.exportSymbol('proto.himpb.EMsg.MsgStatus', null, global);
goog.exportSymbol('proto.himpb.EMsg.MsgSubStatus', null, global);
goog.exportSymbol('proto.himpb.EMsg.MsgType', null, global);
goog.exportSymbol('proto.himpb.EMsg.RPCType', null, global);
goog.exportSymbol('proto.himpb.MsgRecordGetMsgsReq', null, global);
goog.exportSymbol('proto.himpb.MsgRecordGetMsgsRsp', null, global);
goog.exportSymbol('proto.himpb.MsgRecordGetMyOfflineMsgsReq', null, global);
goog.exportSymbol('proto.himpb.MsgRecordGetMyOfflineMsgsRsp', null, global);
goog.exportSymbol('proto.himpb.MsgRecordGetMyRecentSessionsReq', null, global);
goog.exportSymbol('proto.himpb.MsgRecordGetMyRecentSessionsRsp', null, global);
goog.exportSymbol('proto.himpb.MsgRecordHistoryMsgsReq', null, global);
goog.exportSymbol('proto.himpb.MsgRecordHistoryMsgsRsp', null, global);
goog.exportSymbol('proto.himpb.MsgRecordInBoxReq', null, global);
goog.exportSymbol('proto.himpb.MsgRecordInBoxRsp', null, global);
goog.exportSymbol('proto.himpb.MsgRecordSetStatusReq', null, global);
goog.exportSymbol('proto.himpb.MsgRecordSetStatusRsp', null, global);
goog.exportSymbol('proto.himpb.TMsgBrief', null, global);
goog.exportSymbol('proto.himpb.TMsgCallEventFormat', null, global);
goog.exportSymbol('proto.himpb.TMsgEchoFormat', null, global);
goog.exportSymbol('proto.himpb.TMsgEntity', null, global);
goog.exportSymbol('proto.himpb.TMsgFileFormat', null, global);
goog.exportSymbol('proto.himpb.TMsgGeoFormat', null, global);
goog.exportSymbol('proto.himpb.TMsgGpsFormat', null, global);
goog.exportSymbol('proto.himpb.TMsgGpsFormat.Gps', null, global);
goog.exportSymbol('proto.himpb.TMsgGroupOpEventFormat', null, global);
goog.exportSymbol('proto.himpb.TMsgImageFormat', null, global);
goog.exportSymbol('proto.himpb.TMsgSession', null, global);
goog.exportSymbol('proto.himpb.TMsgSmallVideoFormat', null, global);
goog.exportSymbol('proto.himpb.TMsgSpeechFormat', null, global);
goog.exportSymbol('proto.himpb.TMsgTransport', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.EMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.EMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.EMsg.displayName = 'proto.himpb.EMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgBrief = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TMsgBrief, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgBrief.displayName = 'proto.himpb.TMsgBrief';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TMsgEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgEntity.displayName = 'proto.himpb.TMsgEntity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgSession = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TMsgSession, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgSession.displayName = 'proto.himpb.TMsgSession';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgImageFormat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TMsgImageFormat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgImageFormat.displayName = 'proto.himpb.TMsgImageFormat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgSpeechFormat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TMsgSpeechFormat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgSpeechFormat.displayName = 'proto.himpb.TMsgSpeechFormat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgSmallVideoFormat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TMsgSmallVideoFormat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgSmallVideoFormat.displayName = 'proto.himpb.TMsgSmallVideoFormat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgGeoFormat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.TMsgGeoFormat.repeatedFields_, null);
};
goog.inherits(proto.himpb.TMsgGeoFormat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgGeoFormat.displayName = 'proto.himpb.TMsgGeoFormat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgGpsFormat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.TMsgGpsFormat.repeatedFields_, null);
};
goog.inherits(proto.himpb.TMsgGpsFormat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgGpsFormat.displayName = 'proto.himpb.TMsgGpsFormat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgGpsFormat.Gps = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TMsgGpsFormat.Gps, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgGpsFormat.Gps.displayName = 'proto.himpb.TMsgGpsFormat.Gps';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgTransport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TMsgTransport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgTransport.displayName = 'proto.himpb.TMsgTransport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgEchoFormat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.TMsgEchoFormat.repeatedFields_, null);
};
goog.inherits(proto.himpb.TMsgEchoFormat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgEchoFormat.displayName = 'proto.himpb.TMsgEchoFormat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgFileFormat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TMsgFileFormat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgFileFormat.displayName = 'proto.himpb.TMsgFileFormat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgGroupOpEventFormat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.TMsgGroupOpEventFormat.repeatedFields_, null);
};
goog.inherits(proto.himpb.TMsgGroupOpEventFormat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgGroupOpEventFormat.displayName = 'proto.himpb.TMsgGroupOpEventFormat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.TMsgCallEventFormat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.TMsgCallEventFormat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.TMsgCallEventFormat.displayName = 'proto.himpb.TMsgCallEventFormat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MsgRecordInBoxReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.MsgRecordInBoxReq.repeatedFields_, null);
};
goog.inherits(proto.himpb.MsgRecordInBoxReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MsgRecordInBoxReq.displayName = 'proto.himpb.MsgRecordInBoxReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MsgRecordInBoxRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.MsgRecordInBoxRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MsgRecordInBoxRsp.displayName = 'proto.himpb.MsgRecordInBoxRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MsgRecordSetStatusReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.MsgRecordSetStatusReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MsgRecordSetStatusReq.displayName = 'proto.himpb.MsgRecordSetStatusReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MsgRecordSetStatusRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.MsgRecordSetStatusRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MsgRecordSetStatusRsp.displayName = 'proto.himpb.MsgRecordSetStatusRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MsgRecordGetMsgsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.MsgRecordGetMsgsReq.repeatedFields_, null);
};
goog.inherits(proto.himpb.MsgRecordGetMsgsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MsgRecordGetMsgsReq.displayName = 'proto.himpb.MsgRecordGetMsgsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MsgRecordGetMsgsRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.MsgRecordGetMsgsRsp.repeatedFields_, null);
};
goog.inherits(proto.himpb.MsgRecordGetMsgsRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MsgRecordGetMsgsRsp.displayName = 'proto.himpb.MsgRecordGetMsgsRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MsgRecordHistoryMsgsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.MsgRecordHistoryMsgsReq.repeatedFields_, null);
};
goog.inherits(proto.himpb.MsgRecordHistoryMsgsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MsgRecordHistoryMsgsReq.displayName = 'proto.himpb.MsgRecordHistoryMsgsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MsgRecordHistoryMsgsRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.MsgRecordHistoryMsgsRsp.repeatedFields_, null);
};
goog.inherits(proto.himpb.MsgRecordHistoryMsgsRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MsgRecordHistoryMsgsRsp.displayName = 'proto.himpb.MsgRecordHistoryMsgsRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.MsgRecordGetMyOfflineMsgsReq.repeatedFields_, null);
};
goog.inherits(proto.himpb.MsgRecordGetMyOfflineMsgsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MsgRecordGetMyOfflineMsgsReq.displayName = 'proto.himpb.MsgRecordGetMyOfflineMsgsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.MsgRecordGetMyOfflineMsgsRsp.repeatedFields_, null);
};
goog.inherits(proto.himpb.MsgRecordGetMyOfflineMsgsRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MsgRecordGetMyOfflineMsgsRsp.displayName = 'proto.himpb.MsgRecordGetMyOfflineMsgsRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.MsgRecordGetMyRecentSessionsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MsgRecordGetMyRecentSessionsReq.displayName = 'proto.himpb.MsgRecordGetMyRecentSessionsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.MsgRecordGetMyRecentSessionsRsp.repeatedFields_, null);
};
goog.inherits(proto.himpb.MsgRecordGetMyRecentSessionsRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.MsgRecordGetMyRecentSessionsRsp.displayName = 'proto.himpb.MsgRecordGetMyRecentSessionsRsp';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.EMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.EMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.EMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.EMsg.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.EMsg}
 */
proto.himpb.EMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.EMsg;
  return proto.himpb.EMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.EMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.EMsg}
 */
proto.himpb.EMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.EMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.EMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.EMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.EMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.himpb.EMsg.MsgMode = {
  PRIVATE_MSG: 0,
  GROUP_MSG: 1,
  SIGNALING_SESSION_MSG: 2,
  SERVER_MSG: 3,
  SYSTEM_MSG: 4,
  SYSTEM_AD: 5,
  APP_NOTIFY: 6,
  APP_ONLINE_HELP: 7,
  APP_CONF: 8,
  APP_AUTO_REPLAY: 101
};

/**
 * @enum {number}
 */
proto.himpb.EMsg.MsgStatus = {
  MSG_STATUS_NONE: 0,
  MSG_STATUS_UNREAD: 1,
  MSG_STATUS_READ: 2,
  MSG_STATUS_DELETED: 3,
  MSG_STATUS_SENDING: 4,
  MSG_STATUS_SEND_FAILED: 5,
  MSG_STATUS_SENT: 6,
  MSG_STATUS_RECEIPT_ACCEPTED: 7,
  MSG_STATUS_RECEIPT_REFUSED: 8,
  MSG_STATUS_DRAFT: 9,
  MSG_STATUS_SEND_CANCEL: 10
};

/**
 * @enum {number}
 */
proto.himpb.EMsg.MsgSubStatus = {
  MSG_SUB_STATUS_NONE: 0,
  MSG_SUB_STATUS_NOT_PLAYING: 20,
  MSG_SUB_STATUS_PLAYED: 21
};

/**
 * @enum {number}
 */
proto.himpb.EMsg.EncodeType = {
  RAW_FORMAT_ENCODING: 0,
  JSON_FORMAT_ENCODING: 1,
  PROBUF_FORMAT_ENCODING: 2
};

/**
 * @enum {number}
 */
proto.himpb.EMsg.MsgType = {
  MSG_TYPE_TEXT: 0,
  MSG_TYPE_IMAGE: 1,
  MSG_TYPE_FILE: 2,
  MSG_TYPE_HTML: 3,
  MSG_TYPE_CHAT: 4,
  MSG_TYPE_GEO: 5,
  MSG_TYPE_RED_PACKET: 6,
  MSG_TYPE_PAY: 7,
  MSG_TYPE_SPEECH: 8,
  MSG_TYPE_SMALL_VIDEO: 9,
  MSG_TYPE_PERSONAL_CARD: 10,
  MSG_TYPE_MY_COLLECTION: 11,
  MSG_TYPE_CALL: 12,
  MSG_TYPE_MEETING: 13,
  MSG_TYPE_GPS: 14,
  MSG_TYPE_MEME: 20,
  MSG_TYPE_STICKER: 21,
  MSG_TYPE_EVENT: 50,
  MSG_TYPE_ECHO: 97,
  MSG_TYPE_MAX: 98,
  MSG_OP_MIN: 99,
  MSG_OP_GROUP_CREATE_REQ: 100,
  MSG_OP_GROUP_LOAD_NTY: 101,
  MSG_OP_GROUP_INVITE_REQ: 105,
  MSG_OP_GROUP_INVITE_NTY: 106,
  MSG_OP_GROUP_INVITE_RCP_ACCEPT: 107,
  MSG_OP_GROUP_INVITE_RCP_REJECT: 108,
  MSG_OP_GROUP_KICK: 110,
  MSG_OP_GROUP_DISMISS: 111,
  MSG_OP_GROUP_EXIT: 112,
  MSG_OP_GROUP_SYNC: 116,
  MSG_OP_CONF_INVITE_NTY: 130,
  MSG_OP_CONF_UPDATE_NTY: 131,
  MSG_OP_CONF_ADD_FILES_NTY: 132,
  MSG_OP_CONF_REMOVE_MEMBER_NTY: 133,
  MSG_OP_CONF_CANCEL_NTY: 134,
  MSG_OP_CONF_STOP_NTY: 135,
  MSG_OP_MAX: 199,
  MSG_TYPE_CUSTOM: 200,
  MSG_TYPE_POINT_ANNOTATION_OLD: 201,
  MSG_TYPE_POINT_ANNOTATION: 202,
  MSG_TYPE_ARROW_ANNOTATION: 203,
  MSG_TYPE_CIRCLE_ANNOTATION: 204,
  MSG_TYPE_RECTANGLE_ANNOTATION: 205,
  MSG_TYPE_SLAM_INNER_TEXTURE_ANNOTATION: 206,
  MSG_TYPE_SLAM_CUSTOM_TEXTURE_ANNOTATION: 207,
  MSG_TYPE_SLAM_GRAFFITI_ANNOTATION: 208,
  MSG_TYPE_GRAFFITI_ANNOTATION: 209,
  MSG_TYPE_REVOKE: 210,
  MSG_TYPE_CLEAR: 211,
  MSG_TYPE_CAMERA_FOCUS: 212,
  MSG_TYPE_CAMERA_ZOOM: 213
};

/**
 * @enum {number}
 */
proto.himpb.EMsg.RPCType = {
  RPC_TYPE_DEFAULT: 0,
  RPC_TYPE_GET_USER_STATUS: 1,
  RPC_TYPE_GROUP_MIN: 10,
  RPC_TYPE_GROUP_CREATE: 11,
  RPC_TYPE_GROUP_INVITE: 12,
  RPC_TYPE_GROUP_KICK: 13,
  RPC_TYPE_GROUP_JOIN: 14,
  RPC_TYPE_GROUP_EXIT: 15,
  RPC_TYPE_GROUP_DISMISS: 16,
  RPC_TYPE_GROUP_INVITE_RCP_ACCEPT: 17,
  RPC_TYPE_GROUP_INVITE_RCP_REJECT: 18,
  RPC_TYPE_GROUP_QUERY_ALL_MY_GROUPS: 19,
  RPC_TYPE_GROUP_QUERY_GROUP_INFOS: 20,
  RPC_TYPE_GROUP_QUERY_GROUP_DETAIL: 21,
  RPC_TYPE_GROUP_QUERY_ALL_MEMBER_INFOS: 22,
  RPC_TYPE_GROUP_QUERY_GROUP_MEMBER: 23,
  RPC_TYPE_GROUP_UPDATE_GROUP_INFO: 24,
  RPC_TYPE_GROUP_UPDATE_MEMBER_NICK: 25,
  RPC_TYPE_GROUP_MUTE_MEMBER_OR_NOT: 26,
  RPC_TYPE_GROUP_MUTE_GROUP_OR_NOT: 27,
  RPC_TYPE_GROUP_QUERY_MUTE_MEMBERS: 28,
  RPC_TYPE_GROUP_MAX: 99,
  RPC_TYPE_SIGNALING_MIN: 100,
  RPC_TYPE_SIGNALING_SESSION_CANCLE: 101,
  RPC_TYPE_SIGNALING_SESSION_REJECT: 102,
  RPC_TYPE_SIGNALING_SESSION_ACCEPT: 103,
  RPC_TYPE_SIGNALING_SESSION_LEAVE: 104,
  RPC_TYPE_SIGNALING_SESSION_CTRL_REQ: 105,
  RPC_TYPE_SIGNALING_SESSION_CTRL_RCP: 106,
  RPC_TYPE_SIGNALING_LIVEBROADCAST_REQ: 107,
  RPC_TYPE_SIGNALING_MAX: 199,
  RPC_TYPE_MSG_RECORD_MIN: 200,
  RPC_TYPE_MSG_RECORD_SET_STATUS: 201,
  RPC_TYPE_MSG_RECORD_GET_MSGS: 202,
  RPC_TYPE_MSG_RECORD_HISTORY_MSGS: 203,
  RPC_TYPE_MSG_RECORD_GET_MY_OFFLINE_MSGS: 204,
  RPC_TYPE_MSG_RECORD_GET_MY_RECENT_SESSIONS: 205,
  RPC_TYPE_MSG_RECORD_MAX: 299
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgBrief.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgBrief.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgBrief} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgBrief.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    encodetype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    clientseqnum: jspb.Message.getFieldWithDefault(msg, 4, 0),
    serverseqnum: jspb.Message.getFieldWithDefault(msg, 5, 0),
    msgid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    millisecondssend: jspb.Message.getFieldWithDefault(msg, 7, 0),
    millisecondsdeliver: jspb.Message.getFieldWithDefault(msg, 8, 0),
    reserved: jspb.Message.getFieldWithDefault(msg, 9, 0),
    senderid: jspb.Message.getFieldWithDefault(msg, 10, ""),
    sendername: jspb.Message.getFieldWithDefault(msg, 11, ""),
    senderextinfo: jspb.Message.getFieldWithDefault(msg, 12, ""),
    receiverid: jspb.Message.getFieldWithDefault(msg, 13, ""),
    status: jspb.Message.getFieldWithDefault(msg, 14, 0),
    substatus: jspb.Message.getFieldWithDefault(msg, 15, 0),
    source: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgBrief}
 */
proto.himpb.TMsgBrief.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgBrief;
  return proto.himpb.TMsgBrief.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgBrief} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgBrief}
 */
proto.himpb.TMsgBrief.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.himpb.EMsg.MsgMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = /** @type {!proto.himpb.EMsg.MsgType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {!proto.himpb.EMsg.EncodeType} */ (reader.readEnum());
      msg.setEncodetype(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setClientseqnum(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setServerseqnum(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMillisecondssend(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMillisecondsdeliver(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReserved(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSenderid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSendername(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setSenderextinfo(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiverid(value);
      break;
    case 14:
      var value = /** @type {!proto.himpb.EMsg.MsgStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 15:
      var value = /** @type {!proto.himpb.EMsg.MsgSubStatus} */ (reader.readEnum());
      msg.setSubstatus(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgBrief.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgBrief.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgBrief} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgBrief.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEncodetype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getClientseqnum();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getServerseqnum();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMillisecondssend();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getMillisecondsdeliver();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getReserved();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getSenderid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSendername();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getSenderextinfo();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getReceiverid();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getSubstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional EMsg.MsgMode mode = 1;
 * @return {!proto.himpb.EMsg.MsgMode}
 */
proto.himpb.TMsgBrief.prototype.getMode = function() {
  return /** @type {!proto.himpb.EMsg.MsgMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgMode} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional EMsg.MsgType type = 2;
 * @return {!proto.himpb.EMsg.MsgType}
 */
proto.himpb.TMsgBrief.prototype.getType = function() {
  return /** @type {!proto.himpb.EMsg.MsgType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgType} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional EMsg.EncodeType EncodeType = 3;
 * @return {!proto.himpb.EMsg.EncodeType}
 */
proto.himpb.TMsgBrief.prototype.getEncodetype = function() {
  return /** @type {!proto.himpb.EMsg.EncodeType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.himpb.EMsg.EncodeType} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setEncodetype = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional uint32 clientSeqNum = 4;
 * @return {number}
 */
proto.himpb.TMsgBrief.prototype.getClientseqnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setClientseqnum = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 serverSeqNum = 5;
 * @return {number}
 */
proto.himpb.TMsgBrief.prototype.getServerseqnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setServerseqnum = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string msgId = 6;
 * @return {string}
 */
proto.himpb.TMsgBrief.prototype.getMsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setMsgid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 millisecondsSend = 7;
 * @return {number}
 */
proto.himpb.TMsgBrief.prototype.getMillisecondssend = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setMillisecondssend = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 millisecondsDeliver = 8;
 * @return {number}
 */
proto.himpb.TMsgBrief.prototype.getMillisecondsdeliver = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setMillisecondsdeliver = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 reserved = 9;
 * @return {number}
 */
proto.himpb.TMsgBrief.prototype.getReserved = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setReserved = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string senderId = 10;
 * @return {string}
 */
proto.himpb.TMsgBrief.prototype.getSenderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setSenderid = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string senderName = 11;
 * @return {string}
 */
proto.himpb.TMsgBrief.prototype.getSendername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setSendername = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string senderExtInfo = 12;
 * @return {string}
 */
proto.himpb.TMsgBrief.prototype.getSenderextinfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setSenderextinfo = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string receiverId = 13;
 * @return {string}
 */
proto.himpb.TMsgBrief.prototype.getReceiverid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setReceiverid = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional EMsg.MsgStatus status = 14;
 * @return {!proto.himpb.EMsg.MsgStatus}
 */
proto.himpb.TMsgBrief.prototype.getStatus = function() {
  return /** @type {!proto.himpb.EMsg.MsgStatus} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgStatus} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional EMsg.MsgSubStatus subStatus = 15;
 * @return {!proto.himpb.EMsg.MsgSubStatus}
 */
proto.himpb.TMsgBrief.prototype.getSubstatus = function() {
  return /** @type {!proto.himpb.EMsg.MsgSubStatus} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgSubStatus} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setSubstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional string source = 16;
 * @return {string}
 */
proto.himpb.TMsgBrief.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgBrief} returns this
 */
proto.himpb.TMsgBrief.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
    brief: (f = msg.getBrief()) && proto.himpb.TMsgBrief.toObject(includeInstance, f),
    body: msg.getBody_asB64(),
    ext: msg.getExt_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgEntity}
 */
proto.himpb.TMsgEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgEntity;
  return proto.himpb.TMsgEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgEntity}
 */
proto.himpb.TMsgEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.himpb.TMsgBrief;
      reader.readMessage(value,proto.himpb.TMsgBrief.deserializeBinaryFromReader);
      msg.setBrief(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBody(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setExt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrief();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.himpb.TMsgBrief.serializeBinaryToWriter
    );
  }
  f = message.getBody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
  f = message.getExt_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional TMsgBrief brief = 1;
 * @return {?proto.himpb.TMsgBrief}
 */
proto.himpb.TMsgEntity.prototype.getBrief = function() {
  return /** @type{?proto.himpb.TMsgBrief} */ (
    jspb.Message.getWrapperField(this, proto.himpb.TMsgBrief, 1));
};


/**
 * @param {?proto.himpb.TMsgBrief|undefined} value
 * @return {!proto.himpb.TMsgEntity} returns this
*/
proto.himpb.TMsgEntity.prototype.setBrief = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.TMsgEntity} returns this
 */
proto.himpb.TMsgEntity.prototype.clearBrief = function() {
  return this.setBrief(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.TMsgEntity.prototype.hasBrief = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes body = 2;
 * @return {string}
 */
proto.himpb.TMsgEntity.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes body = 2;
 * This is a type-conversion wrapper around `getBody()`
 * @return {string}
 */
proto.himpb.TMsgEntity.prototype.getBody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBody()));
};


/**
 * optional bytes body = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBody()`
 * @return {!Uint8Array}
 */
proto.himpb.TMsgEntity.prototype.getBody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBody()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.himpb.TMsgEntity} returns this
 */
proto.himpb.TMsgEntity.prototype.setBody = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional bytes ext = 3;
 * @return {string}
 */
proto.himpb.TMsgEntity.prototype.getExt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes ext = 3;
 * This is a type-conversion wrapper around `getExt()`
 * @return {string}
 */
proto.himpb.TMsgEntity.prototype.getExt_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getExt()));
};


/**
 * optional bytes ext = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getExt()`
 * @return {!Uint8Array}
 */
proto.himpb.TMsgEntity.prototype.getExt_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getExt()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.himpb.TMsgEntity} returns this
 */
proto.himpb.TMsgEntity.prototype.setExt = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgSession.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgSession.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgSession} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgSession.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sessionid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sessiontime: jspb.Message.getFieldWithDefault(msg, 3, 0),
    msgid: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgSession}
 */
proto.himpb.TMsgSession.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgSession;
  return proto.himpb.TMsgSession.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgSession} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgSession}
 */
proto.himpb.TMsgSession.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.himpb.EMsg.MsgMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSessiontime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgSession.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgSession.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgSession} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgSession.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSessiontime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional EMsg.MsgMode mode = 1;
 * @return {!proto.himpb.EMsg.MsgMode}
 */
proto.himpb.TMsgSession.prototype.getMode = function() {
  return /** @type {!proto.himpb.EMsg.MsgMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgMode} value
 * @return {!proto.himpb.TMsgSession} returns this
 */
proto.himpb.TMsgSession.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string sessionId = 2;
 * @return {string}
 */
proto.himpb.TMsgSession.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgSession} returns this
 */
proto.himpb.TMsgSession.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 sessionTime = 3;
 * @return {number}
 */
proto.himpb.TMsgSession.prototype.getSessiontime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgSession} returns this
 */
proto.himpb.TMsgSession.prototype.setSessiontime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string msgId = 4;
 * @return {string}
 */
proto.himpb.TMsgSession.prototype.getMsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgSession} returns this
 */
proto.himpb.TMsgSession.prototype.setMsgid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgImageFormat.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgImageFormat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgImageFormat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgImageFormat.toObject = function(includeInstance, msg) {
  var f, obj = {
    nm: jspb.Message.getFieldWithDefault(msg, 1, ""),
    md5: jspb.Message.getFieldWithDefault(msg, 2, ""),
    url: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ext: jspb.Message.getFieldWithDefault(msg, 4, ""),
    w: jspb.Message.getFieldWithDefault(msg, 5, 0),
    h: jspb.Message.getFieldWithDefault(msg, 6, 0),
    s: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgImageFormat}
 */
proto.himpb.TMsgImageFormat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgImageFormat;
  return proto.himpb.TMsgImageFormat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgImageFormat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgImageFormat}
 */
proto.himpb.TMsgImageFormat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNm(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMd5(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setW(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setH(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setS(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgImageFormat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgImageFormat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgImageFormat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgImageFormat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNm();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMd5();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExt();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getW();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getH();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getS();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
};


/**
 * optional string nm = 1;
 * @return {string}
 */
proto.himpb.TMsgImageFormat.prototype.getNm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgImageFormat} returns this
 */
proto.himpb.TMsgImageFormat.prototype.setNm = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string md5 = 2;
 * @return {string}
 */
proto.himpb.TMsgImageFormat.prototype.getMd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgImageFormat} returns this
 */
proto.himpb.TMsgImageFormat.prototype.setMd5 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.himpb.TMsgImageFormat.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgImageFormat} returns this
 */
proto.himpb.TMsgImageFormat.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ext = 4;
 * @return {string}
 */
proto.himpb.TMsgImageFormat.prototype.getExt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgImageFormat} returns this
 */
proto.himpb.TMsgImageFormat.prototype.setExt = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 w = 5;
 * @return {number}
 */
proto.himpb.TMsgImageFormat.prototype.getW = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgImageFormat} returns this
 */
proto.himpb.TMsgImageFormat.prototype.setW = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 h = 6;
 * @return {number}
 */
proto.himpb.TMsgImageFormat.prototype.getH = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgImageFormat} returns this
 */
proto.himpb.TMsgImageFormat.prototype.setH = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 s = 7;
 * @return {number}
 */
proto.himpb.TMsgImageFormat.prototype.getS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgImageFormat} returns this
 */
proto.himpb.TMsgImageFormat.prototype.setS = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgSpeechFormat.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgSpeechFormat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgSpeechFormat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgSpeechFormat.toObject = function(includeInstance, msg) {
  var f, obj = {
    dur: jspb.Message.getFieldWithDefault(msg, 1, 0),
    md5: jspb.Message.getFieldWithDefault(msg, 2, ""),
    url: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ext: jspb.Message.getFieldWithDefault(msg, 4, ""),
    s: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgSpeechFormat}
 */
proto.himpb.TMsgSpeechFormat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgSpeechFormat;
  return proto.himpb.TMsgSpeechFormat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgSpeechFormat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgSpeechFormat}
 */
proto.himpb.TMsgSpeechFormat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDur(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMd5(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExt(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setS(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgSpeechFormat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgSpeechFormat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgSpeechFormat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgSpeechFormat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDur();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getMd5();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExt();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getS();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional uint32 dur = 1;
 * @return {number}
 */
proto.himpb.TMsgSpeechFormat.prototype.getDur = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgSpeechFormat} returns this
 */
proto.himpb.TMsgSpeechFormat.prototype.setDur = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string md5 = 2;
 * @return {string}
 */
proto.himpb.TMsgSpeechFormat.prototype.getMd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgSpeechFormat} returns this
 */
proto.himpb.TMsgSpeechFormat.prototype.setMd5 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.himpb.TMsgSpeechFormat.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgSpeechFormat} returns this
 */
proto.himpb.TMsgSpeechFormat.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ext = 4;
 * @return {string}
 */
proto.himpb.TMsgSpeechFormat.prototype.getExt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgSpeechFormat} returns this
 */
proto.himpb.TMsgSpeechFormat.prototype.setExt = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string s = 5;
 * @return {string}
 */
proto.himpb.TMsgSpeechFormat.prototype.getS = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgSpeechFormat} returns this
 */
proto.himpb.TMsgSpeechFormat.prototype.setS = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgSmallVideoFormat.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgSmallVideoFormat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgSmallVideoFormat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgSmallVideoFormat.toObject = function(includeInstance, msg) {
  var f, obj = {
    dur: jspb.Message.getFieldWithDefault(msg, 1, 0),
    md5: jspb.Message.getFieldWithDefault(msg, 2, ""),
    url: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ext: jspb.Message.getFieldWithDefault(msg, 4, ""),
    w: jspb.Message.getFieldWithDefault(msg, 5, 0),
    h: jspb.Message.getFieldWithDefault(msg, 6, 0),
    s: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgSmallVideoFormat}
 */
proto.himpb.TMsgSmallVideoFormat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgSmallVideoFormat;
  return proto.himpb.TMsgSmallVideoFormat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgSmallVideoFormat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgSmallVideoFormat}
 */
proto.himpb.TMsgSmallVideoFormat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDur(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMd5(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setW(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setH(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setS(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgSmallVideoFormat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgSmallVideoFormat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgSmallVideoFormat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgSmallVideoFormat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDur();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getMd5();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExt();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getW();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getH();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getS();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
};


/**
 * optional uint32 dur = 1;
 * @return {number}
 */
proto.himpb.TMsgSmallVideoFormat.prototype.getDur = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgSmallVideoFormat} returns this
 */
proto.himpb.TMsgSmallVideoFormat.prototype.setDur = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string md5 = 2;
 * @return {string}
 */
proto.himpb.TMsgSmallVideoFormat.prototype.getMd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgSmallVideoFormat} returns this
 */
proto.himpb.TMsgSmallVideoFormat.prototype.setMd5 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.himpb.TMsgSmallVideoFormat.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgSmallVideoFormat} returns this
 */
proto.himpb.TMsgSmallVideoFormat.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ext = 4;
 * @return {string}
 */
proto.himpb.TMsgSmallVideoFormat.prototype.getExt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgSmallVideoFormat} returns this
 */
proto.himpb.TMsgSmallVideoFormat.prototype.setExt = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 w = 5;
 * @return {number}
 */
proto.himpb.TMsgSmallVideoFormat.prototype.getW = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgSmallVideoFormat} returns this
 */
proto.himpb.TMsgSmallVideoFormat.prototype.setW = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint32 h = 6;
 * @return {number}
 */
proto.himpb.TMsgSmallVideoFormat.prototype.getH = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgSmallVideoFormat} returns this
 */
proto.himpb.TMsgSmallVideoFormat.prototype.setH = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 s = 7;
 * @return {number}
 */
proto.himpb.TMsgSmallVideoFormat.prototype.getS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgSmallVideoFormat} returns this
 */
proto.himpb.TMsgSmallVideoFormat.prototype.setS = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.TMsgGeoFormat.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgGeoFormat.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgGeoFormat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgGeoFormat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgGeoFormat.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    geoList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgGeoFormat}
 */
proto.himpb.TMsgGeoFormat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgGeoFormat;
  return proto.himpb.TMsgGeoFormat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgGeoFormat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgGeoFormat}
 */
proto.himpb.TMsgGeoFormat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedFloat() : [reader.readFloat()]);
      for (var i = 0; i < values.length; i++) {
        msg.addGeo(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgGeoFormat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgGeoFormat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgGeoFormat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgGeoFormat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGeoList();
  if (f.length > 0) {
    writer.writePackedFloat(
      2,
      f
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.himpb.TMsgGeoFormat.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgGeoFormat} returns this
 */
proto.himpb.TMsgGeoFormat.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated float geo = 2;
 * @return {!Array<number>}
 */
proto.himpb.TMsgGeoFormat.prototype.getGeoList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.himpb.TMsgGeoFormat} returns this
 */
proto.himpb.TMsgGeoFormat.prototype.setGeoList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.himpb.TMsgGeoFormat} returns this
 */
proto.himpb.TMsgGeoFormat.prototype.addGeo = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.TMsgGeoFormat} returns this
 */
proto.himpb.TMsgGeoFormat.prototype.clearGeoList = function() {
  return this.setGeoList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.TMsgGpsFormat.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgGpsFormat.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgGpsFormat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgGpsFormat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgGpsFormat.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    udid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    msgList: jspb.Message.toObjectList(msg.getMsgList(),
    proto.himpb.TMsgGpsFormat.Gps.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgGpsFormat}
 */
proto.himpb.TMsgGpsFormat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgGpsFormat;
  return proto.himpb.TMsgGpsFormat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgGpsFormat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgGpsFormat}
 */
proto.himpb.TMsgGpsFormat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUdid(value);
      break;
    case 3:
      var value = new proto.himpb.TMsgGpsFormat.Gps;
      reader.readMessage(value,proto.himpb.TMsgGpsFormat.Gps.deserializeBinaryFromReader);
      msg.addMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgGpsFormat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgGpsFormat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgGpsFormat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgGpsFormat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUdid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMsgList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.himpb.TMsgGpsFormat.Gps.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgGpsFormat.Gps.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgGpsFormat.Gps.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgGpsFormat.Gps} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgGpsFormat.Gps.toObject = function(includeInstance, msg) {
  var f, obj = {
    latitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    longitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    precision: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    altitude: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    timestamp: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgGpsFormat.Gps}
 */
proto.himpb.TMsgGpsFormat.Gps.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgGpsFormat.Gps;
  return proto.himpb.TMsgGpsFormat.Gps.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgGpsFormat.Gps} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgGpsFormat.Gps}
 */
proto.himpb.TMsgGpsFormat.Gps.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLatitude(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLongitude(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPrecision(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAltitude(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgGpsFormat.Gps.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgGpsFormat.Gps.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgGpsFormat.Gps} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgGpsFormat.Gps.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLatitude();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getLongitude();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getPrecision();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getAltitude();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional float latitude = 1;
 * @return {number}
 */
proto.himpb.TMsgGpsFormat.Gps.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgGpsFormat.Gps} returns this
 */
proto.himpb.TMsgGpsFormat.Gps.prototype.setLatitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float longitude = 2;
 * @return {number}
 */
proto.himpb.TMsgGpsFormat.Gps.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgGpsFormat.Gps} returns this
 */
proto.himpb.TMsgGpsFormat.Gps.prototype.setLongitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float precision = 3;
 * @return {number}
 */
proto.himpb.TMsgGpsFormat.Gps.prototype.getPrecision = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgGpsFormat.Gps} returns this
 */
proto.himpb.TMsgGpsFormat.Gps.prototype.setPrecision = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float altitude = 4;
 * @return {number}
 */
proto.himpb.TMsgGpsFormat.Gps.prototype.getAltitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgGpsFormat.Gps} returns this
 */
proto.himpb.TMsgGpsFormat.Gps.prototype.setAltitude = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int64 timestamp = 5;
 * @return {number}
 */
proto.himpb.TMsgGpsFormat.Gps.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgGpsFormat.Gps} returns this
 */
proto.himpb.TMsgGpsFormat.Gps.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.himpb.TMsgGpsFormat.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgGpsFormat} returns this
 */
proto.himpb.TMsgGpsFormat.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string udid = 2;
 * @return {string}
 */
proto.himpb.TMsgGpsFormat.prototype.getUdid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgGpsFormat} returns this
 */
proto.himpb.TMsgGpsFormat.prototype.setUdid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Gps msg = 3;
 * @return {!Array<!proto.himpb.TMsgGpsFormat.Gps>}
 */
proto.himpb.TMsgGpsFormat.prototype.getMsgList = function() {
  return /** @type{!Array<!proto.himpb.TMsgGpsFormat.Gps>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.himpb.TMsgGpsFormat.Gps, 3));
};


/**
 * @param {!Array<!proto.himpb.TMsgGpsFormat.Gps>} value
 * @return {!proto.himpb.TMsgGpsFormat} returns this
*/
proto.himpb.TMsgGpsFormat.prototype.setMsgList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.himpb.TMsgGpsFormat.Gps=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TMsgGpsFormat.Gps}
 */
proto.himpb.TMsgGpsFormat.prototype.addMsg = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.himpb.TMsgGpsFormat.Gps, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.TMsgGpsFormat} returns this
 */
proto.himpb.TMsgGpsFormat.prototype.clearMsgList = function() {
  return this.setMsgList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgTransport.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgTransport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgTransport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgTransport.toObject = function(includeInstance, msg) {
  var f, obj = {
    tick: jspb.Message.getFieldWithDefault(msg, 1, 0),
    info: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgTransport}
 */
proto.himpb.TMsgTransport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgTransport;
  return proto.himpb.TMsgTransport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgTransport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgTransport}
 */
proto.himpb.TMsgTransport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTick(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgTransport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgTransport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgTransport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgTransport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTick();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getInfo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int64 tick = 1;
 * @return {number}
 */
proto.himpb.TMsgTransport.prototype.getTick = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgTransport} returns this
 */
proto.himpb.TMsgTransport.prototype.setTick = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string info = 2;
 * @return {string}
 */
proto.himpb.TMsgTransport.prototype.getInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgTransport} returns this
 */
proto.himpb.TMsgTransport.prototype.setInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.TMsgEchoFormat.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgEchoFormat.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgEchoFormat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgEchoFormat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgEchoFormat.toObject = function(includeInstance, msg) {
  var f, obj = {
    seq: jspb.Message.getFieldWithDefault(msg, 1, 0),
    flag: jspb.Message.getFieldWithDefault(msg, 2, 0),
    src: (f = msg.getSrc()) && proto.himpb.TMsgTransport.toObject(includeInstance, f),
    tgt: (f = msg.getTgt()) && proto.himpb.TMsgTransport.toObject(includeInstance, f),
    midsList: jspb.Message.toObjectList(msg.getMidsList(),
    proto.himpb.TMsgTransport.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgEchoFormat}
 */
proto.himpb.TMsgEchoFormat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgEchoFormat;
  return proto.himpb.TMsgEchoFormat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgEchoFormat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgEchoFormat}
 */
proto.himpb.TMsgEchoFormat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSeq(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFlag(value);
      break;
    case 3:
      var value = new proto.himpb.TMsgTransport;
      reader.readMessage(value,proto.himpb.TMsgTransport.deserializeBinaryFromReader);
      msg.setSrc(value);
      break;
    case 4:
      var value = new proto.himpb.TMsgTransport;
      reader.readMessage(value,proto.himpb.TMsgTransport.deserializeBinaryFromReader);
      msg.setTgt(value);
      break;
    case 5:
      var value = new proto.himpb.TMsgTransport;
      reader.readMessage(value,proto.himpb.TMsgTransport.deserializeBinaryFromReader);
      msg.addMids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgEchoFormat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgEchoFormat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgEchoFormat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgEchoFormat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSeq();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getFlag();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getSrc();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.himpb.TMsgTransport.serializeBinaryToWriter
    );
  }
  f = message.getTgt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.himpb.TMsgTransport.serializeBinaryToWriter
    );
  }
  f = message.getMidsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.himpb.TMsgTransport.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 seq = 1;
 * @return {number}
 */
proto.himpb.TMsgEchoFormat.prototype.getSeq = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgEchoFormat} returns this
 */
proto.himpb.TMsgEchoFormat.prototype.setSeq = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 flag = 2;
 * @return {number}
 */
proto.himpb.TMsgEchoFormat.prototype.getFlag = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgEchoFormat} returns this
 */
proto.himpb.TMsgEchoFormat.prototype.setFlag = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional TMsgTransport src = 3;
 * @return {?proto.himpb.TMsgTransport}
 */
proto.himpb.TMsgEchoFormat.prototype.getSrc = function() {
  return /** @type{?proto.himpb.TMsgTransport} */ (
    jspb.Message.getWrapperField(this, proto.himpb.TMsgTransport, 3));
};


/**
 * @param {?proto.himpb.TMsgTransport|undefined} value
 * @return {!proto.himpb.TMsgEchoFormat} returns this
*/
proto.himpb.TMsgEchoFormat.prototype.setSrc = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.TMsgEchoFormat} returns this
 */
proto.himpb.TMsgEchoFormat.prototype.clearSrc = function() {
  return this.setSrc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.TMsgEchoFormat.prototype.hasSrc = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TMsgTransport tgt = 4;
 * @return {?proto.himpb.TMsgTransport}
 */
proto.himpb.TMsgEchoFormat.prototype.getTgt = function() {
  return /** @type{?proto.himpb.TMsgTransport} */ (
    jspb.Message.getWrapperField(this, proto.himpb.TMsgTransport, 4));
};


/**
 * @param {?proto.himpb.TMsgTransport|undefined} value
 * @return {!proto.himpb.TMsgEchoFormat} returns this
*/
proto.himpb.TMsgEchoFormat.prototype.setTgt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.TMsgEchoFormat} returns this
 */
proto.himpb.TMsgEchoFormat.prototype.clearTgt = function() {
  return this.setTgt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.TMsgEchoFormat.prototype.hasTgt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated TMsgTransport mids = 5;
 * @return {!Array<!proto.himpb.TMsgTransport>}
 */
proto.himpb.TMsgEchoFormat.prototype.getMidsList = function() {
  return /** @type{!Array<!proto.himpb.TMsgTransport>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.himpb.TMsgTransport, 5));
};


/**
 * @param {!Array<!proto.himpb.TMsgTransport>} value
 * @return {!proto.himpb.TMsgEchoFormat} returns this
*/
proto.himpb.TMsgEchoFormat.prototype.setMidsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.himpb.TMsgTransport=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TMsgTransport}
 */
proto.himpb.TMsgEchoFormat.prototype.addMids = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.himpb.TMsgTransport, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.TMsgEchoFormat} returns this
 */
proto.himpb.TMsgEchoFormat.prototype.clearMidsList = function() {
  return this.setMidsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgFileFormat.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgFileFormat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgFileFormat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgFileFormat.toObject = function(includeInstance, msg) {
  var f, obj = {
    nm: jspb.Message.getFieldWithDefault(msg, 1, ""),
    md5: jspb.Message.getFieldWithDefault(msg, 2, ""),
    url: jspb.Message.getFieldWithDefault(msg, 3, ""),
    ext: jspb.Message.getFieldWithDefault(msg, 4, ""),
    s: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgFileFormat}
 */
proto.himpb.TMsgFileFormat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgFileFormat;
  return proto.himpb.TMsgFileFormat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgFileFormat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgFileFormat}
 */
proto.himpb.TMsgFileFormat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNm(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMd5(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setS(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgFileFormat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgFileFormat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgFileFormat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgFileFormat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNm();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMd5();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExt();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getS();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional string nm = 1;
 * @return {string}
 */
proto.himpb.TMsgFileFormat.prototype.getNm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgFileFormat} returns this
 */
proto.himpb.TMsgFileFormat.prototype.setNm = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string md5 = 2;
 * @return {string}
 */
proto.himpb.TMsgFileFormat.prototype.getMd5 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgFileFormat} returns this
 */
proto.himpb.TMsgFileFormat.prototype.setMd5 = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string url = 3;
 * @return {string}
 */
proto.himpb.TMsgFileFormat.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgFileFormat} returns this
 */
proto.himpb.TMsgFileFormat.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ext = 4;
 * @return {string}
 */
proto.himpb.TMsgFileFormat.prototype.getExt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgFileFormat} returns this
 */
proto.himpb.TMsgFileFormat.prototype.setExt = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 s = 5;
 * @return {number}
 */
proto.himpb.TMsgFileFormat.prototype.getS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgFileFormat} returns this
 */
proto.himpb.TMsgFileFormat.prototype.setS = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.TMsgGroupOpEventFormat.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgGroupOpEventFormat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgGroupOpEventFormat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgGroupOpEventFormat.toObject = function(includeInstance, msg) {
  var f, obj = {
    event: jspb.Message.getFieldWithDefault(msg, 1, 0),
    grpid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    reserved: jspb.Message.getFieldWithDefault(msg, 3, 0),
    userid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    peeridsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    custominfo: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgGroupOpEventFormat}
 */
proto.himpb.TMsgGroupOpEventFormat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgGroupOpEventFormat;
  return proto.himpb.TMsgGroupOpEventFormat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgGroupOpEventFormat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgGroupOpEventFormat}
 */
proto.himpb.TMsgGroupOpEventFormat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEvent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGrpid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReserved(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addPeerids(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgGroupOpEventFormat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgGroupOpEventFormat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgGroupOpEventFormat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEvent();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getGrpid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getReserved();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPeeridsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional uint32 event = 1;
 * @return {number}
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.getEvent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgGroupOpEventFormat} returns this
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.setEvent = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string grpId = 2;
 * @return {string}
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.getGrpid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgGroupOpEventFormat} returns this
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.setGrpid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 reserved = 3;
 * @return {number}
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.getReserved = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgGroupOpEventFormat} returns this
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.setReserved = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string userId = 4;
 * @return {string}
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgGroupOpEventFormat} returns this
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.setUserid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string peerIds = 5;
 * @return {!Array<string>}
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.getPeeridsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.TMsgGroupOpEventFormat} returns this
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.setPeeridsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.TMsgGroupOpEventFormat} returns this
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.addPeerids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.TMsgGroupOpEventFormat} returns this
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.clearPeeridsList = function() {
  return this.setPeeridsList([]);
};


/**
 * optional string customInfo = 6;
 * @return {string}
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgGroupOpEventFormat} returns this
 */
proto.himpb.TMsgGroupOpEventFormat.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.TMsgCallEventFormat.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.TMsgCallEventFormat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.TMsgCallEventFormat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgCallEventFormat.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    intime: jspb.Message.getFieldWithDefault(msg, 2, 0),
    outtime: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.TMsgCallEventFormat}
 */
proto.himpb.TMsgCallEventFormat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.TMsgCallEventFormat;
  return proto.himpb.TMsgCallEventFormat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.TMsgCallEventFormat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.TMsgCallEventFormat}
 */
proto.himpb.TMsgCallEventFormat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIntime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOuttime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.TMsgCallEventFormat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.TMsgCallEventFormat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.TMsgCallEventFormat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.TMsgCallEventFormat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOuttime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string roomId = 1;
 * @return {string}
 */
proto.himpb.TMsgCallEventFormat.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.TMsgCallEventFormat} returns this
 */
proto.himpb.TMsgCallEventFormat.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 inTime = 2;
 * @return {number}
 */
proto.himpb.TMsgCallEventFormat.prototype.getIntime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgCallEventFormat} returns this
 */
proto.himpb.TMsgCallEventFormat.prototype.setIntime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 outTime = 3;
 * @return {number}
 */
proto.himpb.TMsgCallEventFormat.prototype.getOuttime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.TMsgCallEventFormat} returns this
 */
proto.himpb.TMsgCallEventFormat.prototype.setOuttime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.MsgRecordInBoxReq.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MsgRecordInBoxReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MsgRecordInBoxReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MsgRecordInBoxReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordInBoxReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    serverseqnum: jspb.Message.getFieldWithDefault(msg, 2, 0),
    msgid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    millisecondsdeliver: jspb.Message.getFieldWithDefault(msg, 4, 0),
    senderid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    receiverid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    status: jspb.Message.getFieldWithDefault(msg, 7, 0),
    substatus: jspb.Message.getFieldWithDefault(msg, 8, 0),
    inboxidsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MsgRecordInBoxReq}
 */
proto.himpb.MsgRecordInBoxReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MsgRecordInBoxReq;
  return proto.himpb.MsgRecordInBoxReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MsgRecordInBoxReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MsgRecordInBoxReq}
 */
proto.himpb.MsgRecordInBoxReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.himpb.EMsg.MsgMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setServerseqnum(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMillisecondsdeliver(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSenderid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiverid(value);
      break;
    case 7:
      var value = /** @type {!proto.himpb.EMsg.MsgStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {!proto.himpb.EMsg.MsgSubStatus} */ (reader.readEnum());
      msg.setSubstatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addInboxids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MsgRecordInBoxReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MsgRecordInBoxReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MsgRecordInBoxReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordInBoxReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getServerseqnum();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMillisecondsdeliver();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getSenderid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getReceiverid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getSubstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getInboxidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
};


/**
 * optional EMsg.MsgMode mode = 1;
 * @return {!proto.himpb.EMsg.MsgMode}
 */
proto.himpb.MsgRecordInBoxReq.prototype.getMode = function() {
  return /** @type {!proto.himpb.EMsg.MsgMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgMode} value
 * @return {!proto.himpb.MsgRecordInBoxReq} returns this
 */
proto.himpb.MsgRecordInBoxReq.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional uint32 serverSeqNum = 2;
 * @return {number}
 */
proto.himpb.MsgRecordInBoxReq.prototype.getServerseqnum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MsgRecordInBoxReq} returns this
 */
proto.himpb.MsgRecordInBoxReq.prototype.setServerseqnum = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string msgId = 3;
 * @return {string}
 */
proto.himpb.MsgRecordInBoxReq.prototype.getMsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordInBoxReq} returns this
 */
proto.himpb.MsgRecordInBoxReq.prototype.setMsgid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 millisecondsDeliver = 4;
 * @return {number}
 */
proto.himpb.MsgRecordInBoxReq.prototype.getMillisecondsdeliver = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MsgRecordInBoxReq} returns this
 */
proto.himpb.MsgRecordInBoxReq.prototype.setMillisecondsdeliver = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string senderId = 5;
 * @return {string}
 */
proto.himpb.MsgRecordInBoxReq.prototype.getSenderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordInBoxReq} returns this
 */
proto.himpb.MsgRecordInBoxReq.prototype.setSenderid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string receiverId = 6;
 * @return {string}
 */
proto.himpb.MsgRecordInBoxReq.prototype.getReceiverid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordInBoxReq} returns this
 */
proto.himpb.MsgRecordInBoxReq.prototype.setReceiverid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional EMsg.MsgStatus status = 7;
 * @return {!proto.himpb.EMsg.MsgStatus}
 */
proto.himpb.MsgRecordInBoxReq.prototype.getStatus = function() {
  return /** @type {!proto.himpb.EMsg.MsgStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgStatus} value
 * @return {!proto.himpb.MsgRecordInBoxReq} returns this
 */
proto.himpb.MsgRecordInBoxReq.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional EMsg.MsgSubStatus subStatus = 8;
 * @return {!proto.himpb.EMsg.MsgSubStatus}
 */
proto.himpb.MsgRecordInBoxReq.prototype.getSubstatus = function() {
  return /** @type {!proto.himpb.EMsg.MsgSubStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgSubStatus} value
 * @return {!proto.himpb.MsgRecordInBoxReq} returns this
 */
proto.himpb.MsgRecordInBoxReq.prototype.setSubstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * repeated string inboxIds = 9;
 * @return {!Array<string>}
 */
proto.himpb.MsgRecordInBoxReq.prototype.getInboxidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.MsgRecordInBoxReq} returns this
 */
proto.himpb.MsgRecordInBoxReq.prototype.setInboxidsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.MsgRecordInBoxReq} returns this
 */
proto.himpb.MsgRecordInBoxReq.prototype.addInboxids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MsgRecordInBoxReq} returns this
 */
proto.himpb.MsgRecordInBoxReq.prototype.clearInboxidsList = function() {
  return this.setInboxidsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MsgRecordInBoxRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MsgRecordInBoxRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MsgRecordInBoxRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordInBoxRsp.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MsgRecordInBoxRsp}
 */
proto.himpb.MsgRecordInBoxRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MsgRecordInBoxRsp;
  return proto.himpb.MsgRecordInBoxRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MsgRecordInBoxRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MsgRecordInBoxRsp}
 */
proto.himpb.MsgRecordInBoxRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MsgRecordInBoxRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MsgRecordInBoxRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MsgRecordInBoxRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordInBoxRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MsgRecordSetStatusReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MsgRecordSetStatusReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MsgRecordSetStatusReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordSetStatusReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    device: jspb.Message.getFieldWithDefault(msg, 1, 0),
    mode: jspb.Message.getFieldWithDefault(msg, 2, 0),
    sessionid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    beginmsgid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    endmsgid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    status: jspb.Message.getFieldWithDefault(msg, 6, 0),
    substatus: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MsgRecordSetStatusReq}
 */
proto.himpb.MsgRecordSetStatusReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MsgRecordSetStatusReq;
  return proto.himpb.MsgRecordSetStatusReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MsgRecordSetStatusReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MsgRecordSetStatusReq}
 */
proto.himpb.MsgRecordSetStatusReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDevice(value);
      break;
    case 2:
      var value = /** @type {!proto.himpb.EMsg.MsgMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBeginmsgid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndmsgid(value);
      break;
    case 6:
      var value = /** @type {!proto.himpb.EMsg.MsgStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {!proto.himpb.EMsg.MsgSubStatus} */ (reader.readEnum());
      msg.setSubstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MsgRecordSetStatusReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MsgRecordSetStatusReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MsgRecordSetStatusReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordSetStatusReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevice();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBeginmsgid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEndmsgid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getSubstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional uint32 device = 1;
 * @return {number}
 */
proto.himpb.MsgRecordSetStatusReq.prototype.getDevice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MsgRecordSetStatusReq} returns this
 */
proto.himpb.MsgRecordSetStatusReq.prototype.setDevice = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional EMsg.MsgMode mode = 2;
 * @return {!proto.himpb.EMsg.MsgMode}
 */
proto.himpb.MsgRecordSetStatusReq.prototype.getMode = function() {
  return /** @type {!proto.himpb.EMsg.MsgMode} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgMode} value
 * @return {!proto.himpb.MsgRecordSetStatusReq} returns this
 */
proto.himpb.MsgRecordSetStatusReq.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string sessionId = 3;
 * @return {string}
 */
proto.himpb.MsgRecordSetStatusReq.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordSetStatusReq} returns this
 */
proto.himpb.MsgRecordSetStatusReq.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string beginMsgId = 4;
 * @return {string}
 */
proto.himpb.MsgRecordSetStatusReq.prototype.getBeginmsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordSetStatusReq} returns this
 */
proto.himpb.MsgRecordSetStatusReq.prototype.setBeginmsgid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string endMsgId = 5;
 * @return {string}
 */
proto.himpb.MsgRecordSetStatusReq.prototype.getEndmsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordSetStatusReq} returns this
 */
proto.himpb.MsgRecordSetStatusReq.prototype.setEndmsgid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional EMsg.MsgStatus status = 6;
 * @return {!proto.himpb.EMsg.MsgStatus}
 */
proto.himpb.MsgRecordSetStatusReq.prototype.getStatus = function() {
  return /** @type {!proto.himpb.EMsg.MsgStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgStatus} value
 * @return {!proto.himpb.MsgRecordSetStatusReq} returns this
 */
proto.himpb.MsgRecordSetStatusReq.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional EMsg.MsgSubStatus subStatus = 7;
 * @return {!proto.himpb.EMsg.MsgSubStatus}
 */
proto.himpb.MsgRecordSetStatusReq.prototype.getSubstatus = function() {
  return /** @type {!proto.himpb.EMsg.MsgSubStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgSubStatus} value
 * @return {!proto.himpb.MsgRecordSetStatusReq} returns this
 */
proto.himpb.MsgRecordSetStatusReq.prototype.setSubstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MsgRecordSetStatusRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MsgRecordSetStatusRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordSetStatusRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sessionid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    beginmsgid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    endmsgid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    substatus: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MsgRecordSetStatusRsp}
 */
proto.himpb.MsgRecordSetStatusRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MsgRecordSetStatusRsp;
  return proto.himpb.MsgRecordSetStatusRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MsgRecordSetStatusRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MsgRecordSetStatusRsp}
 */
proto.himpb.MsgRecordSetStatusRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.himpb.EMsg.MsgMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBeginmsgid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEndmsgid(value);
      break;
    case 5:
      var value = /** @type {!proto.himpb.EMsg.MsgStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {!proto.himpb.EMsg.MsgSubStatus} */ (reader.readEnum());
      msg.setSubstatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MsgRecordSetStatusRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MsgRecordSetStatusRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordSetStatusRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBeginmsgid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEndmsgid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSubstatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional EMsg.MsgMode mode = 1;
 * @return {!proto.himpb.EMsg.MsgMode}
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.getMode = function() {
  return /** @type {!proto.himpb.EMsg.MsgMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgMode} value
 * @return {!proto.himpb.MsgRecordSetStatusRsp} returns this
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string sessionId = 2;
 * @return {string}
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordSetStatusRsp} returns this
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string beginMsgId = 3;
 * @return {string}
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.getBeginmsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordSetStatusRsp} returns this
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.setBeginmsgid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string endMsgId = 4;
 * @return {string}
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.getEndmsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordSetStatusRsp} returns this
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.setEndmsgid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional EMsg.MsgStatus status = 5;
 * @return {!proto.himpb.EMsg.MsgStatus}
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.getStatus = function() {
  return /** @type {!proto.himpb.EMsg.MsgStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgStatus} value
 * @return {!proto.himpb.MsgRecordSetStatusRsp} returns this
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional EMsg.MsgSubStatus subStatus = 6;
 * @return {!proto.himpb.EMsg.MsgSubStatus}
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.getSubstatus = function() {
  return /** @type {!proto.himpb.EMsg.MsgSubStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgSubStatus} value
 * @return {!proto.himpb.MsgRecordSetStatusRsp} returns this
 */
proto.himpb.MsgRecordSetStatusRsp.prototype.setSubstatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.MsgRecordGetMsgsReq.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MsgRecordGetMsgsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MsgRecordGetMsgsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MsgRecordGetMsgsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordGetMsgsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sessionid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    msgidsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    ignoreinvalid: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MsgRecordGetMsgsReq}
 */
proto.himpb.MsgRecordGetMsgsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MsgRecordGetMsgsReq;
  return proto.himpb.MsgRecordGetMsgsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MsgRecordGetMsgsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MsgRecordGetMsgsReq}
 */
proto.himpb.MsgRecordGetMsgsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.himpb.EMsg.MsgMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addMsgids(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIgnoreinvalid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MsgRecordGetMsgsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MsgRecordGetMsgsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MsgRecordGetMsgsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordGetMsgsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMsgidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getIgnoreinvalid();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional EMsg.MsgMode mode = 1;
 * @return {!proto.himpb.EMsg.MsgMode}
 */
proto.himpb.MsgRecordGetMsgsReq.prototype.getMode = function() {
  return /** @type {!proto.himpb.EMsg.MsgMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgMode} value
 * @return {!proto.himpb.MsgRecordGetMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMsgsReq.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string sessionId = 2;
 * @return {string}
 */
proto.himpb.MsgRecordGetMsgsReq.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordGetMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMsgsReq.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string msgIds = 3;
 * @return {!Array<string>}
 */
proto.himpb.MsgRecordGetMsgsReq.prototype.getMsgidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.MsgRecordGetMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMsgsReq.prototype.setMsgidsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.MsgRecordGetMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMsgsReq.prototype.addMsgids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MsgRecordGetMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMsgsReq.prototype.clearMsgidsList = function() {
  return this.setMsgidsList([]);
};


/**
 * optional bool ignoreInvalid = 4;
 * @return {boolean}
 */
proto.himpb.MsgRecordGetMsgsReq.prototype.getIgnoreinvalid = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.MsgRecordGetMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMsgsReq.prototype.setIgnoreinvalid = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.MsgRecordGetMsgsRsp.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MsgRecordGetMsgsRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MsgRecordGetMsgsRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordGetMsgsRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sessionid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    msgsList: jspb.Message.toObjectList(msg.getMsgsList(),
    proto.himpb.TMsgEntity.toObject, includeInstance),
    invalidmsgidsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MsgRecordGetMsgsRsp}
 */
proto.himpb.MsgRecordGetMsgsRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MsgRecordGetMsgsRsp;
  return proto.himpb.MsgRecordGetMsgsRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MsgRecordGetMsgsRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MsgRecordGetMsgsRsp}
 */
proto.himpb.MsgRecordGetMsgsRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.himpb.EMsg.MsgMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 3:
      var value = new proto.himpb.TMsgEntity;
      reader.readMessage(value,proto.himpb.TMsgEntity.deserializeBinaryFromReader);
      msg.addMsgs(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addInvalidmsgids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MsgRecordGetMsgsRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MsgRecordGetMsgsRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordGetMsgsRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMsgsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.himpb.TMsgEntity.serializeBinaryToWriter
    );
  }
  f = message.getInvalidmsgidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional EMsg.MsgMode mode = 1;
 * @return {!proto.himpb.EMsg.MsgMode}
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.getMode = function() {
  return /** @type {!proto.himpb.EMsg.MsgMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgMode} value
 * @return {!proto.himpb.MsgRecordGetMsgsRsp} returns this
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string sessionId = 2;
 * @return {string}
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordGetMsgsRsp} returns this
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated TMsgEntity msgs = 3;
 * @return {!Array<!proto.himpb.TMsgEntity>}
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.getMsgsList = function() {
  return /** @type{!Array<!proto.himpb.TMsgEntity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.himpb.TMsgEntity, 3));
};


/**
 * @param {!Array<!proto.himpb.TMsgEntity>} value
 * @return {!proto.himpb.MsgRecordGetMsgsRsp} returns this
*/
proto.himpb.MsgRecordGetMsgsRsp.prototype.setMsgsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.himpb.TMsgEntity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TMsgEntity}
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.addMsgs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.himpb.TMsgEntity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MsgRecordGetMsgsRsp} returns this
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.clearMsgsList = function() {
  return this.setMsgsList([]);
};


/**
 * repeated string invalidMsgIds = 4;
 * @return {!Array<string>}
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.getInvalidmsgidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.MsgRecordGetMsgsRsp} returns this
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.setInvalidmsgidsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.MsgRecordGetMsgsRsp} returns this
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.addInvalidmsgids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MsgRecordGetMsgsRsp} returns this
 */
proto.himpb.MsgRecordGetMsgsRsp.prototype.clearInvalidmsgidsList = function() {
  return this.setInvalidmsgidsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.MsgRecordHistoryMsgsReq.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MsgRecordHistoryMsgsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MsgRecordHistoryMsgsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordHistoryMsgsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sessionid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pagesize: jspb.Message.getFieldWithDefault(msg, 3, 0),
    begintime: jspb.Message.getFieldWithDefault(msg, 4, 0),
    endtime: jspb.Message.getFieldWithDefault(msg, 5, 0),
    msgid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    reverse: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    msgtypesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    isexclusiontype: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq}
 */
proto.himpb.MsgRecordHistoryMsgsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MsgRecordHistoryMsgsReq;
  return proto.himpb.MsgRecordHistoryMsgsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MsgRecordHistoryMsgsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq}
 */
proto.himpb.MsgRecordHistoryMsgsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.himpb.EMsg.MsgMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPagesize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBegintime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndtime(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgid(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReverse(value);
      break;
    case 8:
      var values = /** @type {!Array<!proto.himpb.EMsg.MsgType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addMsgtypes(values[i]);
      }
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsexclusiontype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MsgRecordHistoryMsgsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MsgRecordHistoryMsgsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordHistoryMsgsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPagesize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getBegintime();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getEndtime();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getReverse();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getMsgtypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      8,
      f
    );
  }
  f = message.getIsexclusiontype();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional EMsg.MsgMode mode = 1;
 * @return {!proto.himpb.EMsg.MsgMode}
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.getMode = function() {
  return /** @type {!proto.himpb.EMsg.MsgMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgMode} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq} returns this
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string sessionId = 2;
 * @return {string}
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq} returns this
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 pageSize = 3;
 * @return {number}
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.getPagesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq} returns this
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.setPagesize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 beginTime = 4;
 * @return {number}
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.getBegintime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq} returns this
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.setBegintime = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 endTime = 5;
 * @return {number}
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.getEndtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq} returns this
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.setEndtime = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string msgId = 6;
 * @return {string}
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.getMsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq} returns this
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.setMsgid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool reverse = 7;
 * @return {boolean}
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.getReverse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq} returns this
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.setReverse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * repeated EMsg.MsgType msgTypes = 8;
 * @return {!Array<!proto.himpb.EMsg.MsgType>}
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.getMsgtypesList = function() {
  return /** @type {!Array<!proto.himpb.EMsg.MsgType>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<!proto.himpb.EMsg.MsgType>} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq} returns this
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.setMsgtypesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {!proto.himpb.EMsg.MsgType} value
 * @param {number=} opt_index
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq} returns this
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.addMsgtypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq} returns this
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.clearMsgtypesList = function() {
  return this.setMsgtypesList([]);
};


/**
 * optional bool isExclusionType = 9;
 * @return {boolean}
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.getIsexclusiontype = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsReq} returns this
 */
proto.himpb.MsgRecordHistoryMsgsReq.prototype.setIsexclusiontype = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.MsgRecordHistoryMsgsRsp.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MsgRecordHistoryMsgsRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MsgRecordHistoryMsgsRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MsgRecordHistoryMsgsRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordHistoryMsgsRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    mode: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sessionid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    total: jspb.Message.getFieldWithDefault(msg, 3, 0),
    msgsList: jspb.Message.toObjectList(msg.getMsgsList(),
    proto.himpb.TMsgEntity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MsgRecordHistoryMsgsRsp}
 */
proto.himpb.MsgRecordHistoryMsgsRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MsgRecordHistoryMsgsRsp;
  return proto.himpb.MsgRecordHistoryMsgsRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MsgRecordHistoryMsgsRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MsgRecordHistoryMsgsRsp}
 */
proto.himpb.MsgRecordHistoryMsgsRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.himpb.EMsg.MsgMode} */ (reader.readEnum());
      msg.setMode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotal(value);
      break;
    case 4:
      var value = new proto.himpb.TMsgEntity;
      reader.readMessage(value,proto.himpb.TMsgEntity.deserializeBinaryFromReader);
      msg.addMsgs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MsgRecordHistoryMsgsRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MsgRecordHistoryMsgsRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MsgRecordHistoryMsgsRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordHistoryMsgsRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getMsgsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.himpb.TMsgEntity.serializeBinaryToWriter
    );
  }
};


/**
 * optional EMsg.MsgMode mode = 1;
 * @return {!proto.himpb.EMsg.MsgMode}
 */
proto.himpb.MsgRecordHistoryMsgsRsp.prototype.getMode = function() {
  return /** @type {!proto.himpb.EMsg.MsgMode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.himpb.EMsg.MsgMode} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsRsp} returns this
 */
proto.himpb.MsgRecordHistoryMsgsRsp.prototype.setMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string sessionId = 2;
 * @return {string}
 */
proto.himpb.MsgRecordHistoryMsgsRsp.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsRsp} returns this
 */
proto.himpb.MsgRecordHistoryMsgsRsp.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 total = 3;
 * @return {number}
 */
proto.himpb.MsgRecordHistoryMsgsRsp.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsRsp} returns this
 */
proto.himpb.MsgRecordHistoryMsgsRsp.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated TMsgEntity msgs = 4;
 * @return {!Array<!proto.himpb.TMsgEntity>}
 */
proto.himpb.MsgRecordHistoryMsgsRsp.prototype.getMsgsList = function() {
  return /** @type{!Array<!proto.himpb.TMsgEntity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.himpb.TMsgEntity, 4));
};


/**
 * @param {!Array<!proto.himpb.TMsgEntity>} value
 * @return {!proto.himpb.MsgRecordHistoryMsgsRsp} returns this
*/
proto.himpb.MsgRecordHistoryMsgsRsp.prototype.setMsgsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.himpb.TMsgEntity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TMsgEntity}
 */
proto.himpb.MsgRecordHistoryMsgsRsp.prototype.addMsgs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.himpb.TMsgEntity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MsgRecordHistoryMsgsRsp} returns this
 */
proto.himpb.MsgRecordHistoryMsgsRsp.prototype.clearMsgsList = function() {
  return this.setMsgsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MsgRecordGetMyOfflineMsgsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MsgRecordGetMyOfflineMsgsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    recentdays: jspb.Message.getFieldWithDefault(msg, 1, 0),
    numofflinemsgsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    msgid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    reverse: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    onlymsgidsreturn: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsReq}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MsgRecordGetMyOfflineMsgsReq;
  return proto.himpb.MsgRecordGetMyOfflineMsgsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MsgRecordGetMyOfflineMsgsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsReq}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRecentdays(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addNumofflinemsgs(values[i]);
      }
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgid(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReverse(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOnlymsgidsreturn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MsgRecordGetMyOfflineMsgsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MsgRecordGetMyOfflineMsgsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecentdays();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getNumofflinemsgsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      2,
      f
    );
  }
  f = message.getMsgid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getReverse();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getOnlymsgidsreturn();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional uint32 recentDays = 1;
 * @return {number}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.getRecentdays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.setRecentdays = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated uint32 numOfflineMsgs = 2;
 * @return {!Array<number>}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.getNumofflinemsgsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.setNumofflinemsgsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.addNumofflinemsgs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.clearNumofflinemsgsList = function() {
  return this.setNumofflinemsgsList([]);
};


/**
 * optional string msgId = 3;
 * @return {string}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.getMsgid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.setMsgid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool reverse = 4;
 * @return {boolean}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.getReverse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.setReverse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool onlyMsgIdsReturn = 5;
 * @return {boolean}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.getOnlymsgidsreturn = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsReq} returns this
 */
proto.himpb.MsgRecordGetMyOfflineMsgsReq.prototype.setOnlymsgidsreturn = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MsgRecordGetMyOfflineMsgsRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MsgRecordGetMyOfflineMsgsRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    total: jspb.Message.getFieldWithDefault(msg, 1, 0),
    msgsList: jspb.Message.toObjectList(msg.getMsgsList(),
    proto.himpb.TMsgEntity.toObject, includeInstance),
    msgidsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsRsp}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MsgRecordGetMyOfflineMsgsRsp;
  return proto.himpb.MsgRecordGetMyOfflineMsgsRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MsgRecordGetMyOfflineMsgsRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsRsp}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotal(value);
      break;
    case 2:
      var value = new proto.himpb.TMsgEntity;
      reader.readMessage(value,proto.himpb.TMsgEntity.deserializeBinaryFromReader);
      msg.addMsgs(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addMsgids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MsgRecordGetMyOfflineMsgsRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MsgRecordGetMyOfflineMsgsRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotal();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getMsgsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.himpb.TMsgEntity.serializeBinaryToWriter
    );
  }
  f = message.getMsgidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional uint32 total = 1;
 * @return {number}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsRsp} returns this
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated TMsgEntity msgs = 2;
 * @return {!Array<!proto.himpb.TMsgEntity>}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.prototype.getMsgsList = function() {
  return /** @type{!Array<!proto.himpb.TMsgEntity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.himpb.TMsgEntity, 2));
};


/**
 * @param {!Array<!proto.himpb.TMsgEntity>} value
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsRsp} returns this
*/
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.prototype.setMsgsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.himpb.TMsgEntity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TMsgEntity}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.prototype.addMsgs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.himpb.TMsgEntity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsRsp} returns this
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.prototype.clearMsgsList = function() {
  return this.setMsgsList([]);
};


/**
 * repeated string msgIds = 3;
 * @return {!Array<string>}
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.prototype.getMsgidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsRsp} returns this
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.prototype.setMsgidsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsRsp} returns this
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.prototype.addMsgids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MsgRecordGetMyOfflineMsgsRsp} returns this
 */
proto.himpb.MsgRecordGetMyOfflineMsgsRsp.prototype.clearMsgidsList = function() {
  return this.setMsgidsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MsgRecordGetMyRecentSessionsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MsgRecordGetMyRecentSessionsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    recentdays: jspb.Message.getFieldWithDefault(msg, 1, 0),
    numsessions: jspb.Message.getFieldWithDefault(msg, 2, 0),
    reverse: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    offlineonly: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MsgRecordGetMyRecentSessionsReq}
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MsgRecordGetMyRecentSessionsReq;
  return proto.himpb.MsgRecordGetMyRecentSessionsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MsgRecordGetMyRecentSessionsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MsgRecordGetMyRecentSessionsReq}
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRecentdays(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumsessions(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReverse(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfflineonly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MsgRecordGetMyRecentSessionsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MsgRecordGetMyRecentSessionsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecentdays();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getNumsessions();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getReverse();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getOfflineonly();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional uint32 recentDays = 1;
 * @return {number}
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.prototype.getRecentdays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MsgRecordGetMyRecentSessionsReq} returns this
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.prototype.setRecentdays = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 numSessions = 2;
 * @return {number}
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.prototype.getNumsessions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MsgRecordGetMyRecentSessionsReq} returns this
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.prototype.setNumsessions = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool reverse = 3;
 * @return {boolean}
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.prototype.getReverse = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.MsgRecordGetMyRecentSessionsReq} returns this
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.prototype.setReverse = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool offlineOnly = 4;
 * @return {boolean}
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.prototype.getOfflineonly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.MsgRecordGetMyRecentSessionsReq} returns this
 */
proto.himpb.MsgRecordGetMyRecentSessionsReq.prototype.setOfflineonly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.MsgRecordGetMyRecentSessionsRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.MsgRecordGetMyRecentSessionsRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    total: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sessionsList: jspb.Message.toObjectList(msg.getSessionsList(),
    proto.himpb.TMsgSession.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.MsgRecordGetMyRecentSessionsRsp}
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.MsgRecordGetMyRecentSessionsRsp;
  return proto.himpb.MsgRecordGetMyRecentSessionsRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.MsgRecordGetMyRecentSessionsRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.MsgRecordGetMyRecentSessionsRsp}
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotal(value);
      break;
    case 2:
      var value = new proto.himpb.TMsgSession;
      reader.readMessage(value,proto.himpb.TMsgSession.deserializeBinaryFromReader);
      msg.addSessions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.MsgRecordGetMyRecentSessionsRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.MsgRecordGetMyRecentSessionsRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotal();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSessionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.himpb.TMsgSession.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 total = 1;
 * @return {number}
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.MsgRecordGetMyRecentSessionsRsp} returns this
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated TMsgSession sessions = 2;
 * @return {!Array<!proto.himpb.TMsgSession>}
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp.prototype.getSessionsList = function() {
  return /** @type{!Array<!proto.himpb.TMsgSession>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.himpb.TMsgSession, 2));
};


/**
 * @param {!Array<!proto.himpb.TMsgSession>} value
 * @return {!proto.himpb.MsgRecordGetMyRecentSessionsRsp} returns this
*/
proto.himpb.MsgRecordGetMyRecentSessionsRsp.prototype.setSessionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.himpb.TMsgSession=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TMsgSession}
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp.prototype.addSessions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.himpb.TMsgSession, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.MsgRecordGetMyRecentSessionsRsp} returns this
 */
proto.himpb.MsgRecordGetMyRecentSessionsRsp.prototype.clearSessionsList = function() {
  return this.setSessionsList([]);
};


goog.object.extend(exports, proto.himpb);
